import { useCallback } from 'react';
import { toast } from 'sonner';
import { useIsAuthenticated } from './redux';
import { useGetContactSupportQuery } from '@/store/api/contactSupportApi';

type UseContactSupportOptions = {
  initialMessage?: string;
};

export const useContactSupport = (options?: UseContactSupportOptions) => {
  const isAuthenticated = useIsAuthenticated();

  const { data: contactSupport } = useGetContactSupportQuery();
  const { whatsapp, telegram } = contactSupport ?? {};

  const handleWhatsAppSupportClick = useCallback(() => {
    if (!isAuthenticated) {
      toast.error('Please login to contact our support team.', { id: 'support' });
      return;
    }

    if (!whatsapp) {
      toast.error('WhatsApp support is currently unavailable.', { id: 'support' });
      return;
    }

    const text = encodeURIComponent(options?.initialMessage ?? 'Hello, I need assistance.');

    window.open(`${whatsapp}?text=${text}`, '_blank');
  }, [contactSupport, isAuthenticated, options?.initialMessage]);

  const handleTelegramSupportClick = useCallback(() => {
    if (!isAuthenticated) {
      toast.error('Please login to contact our support team.', { id: 'support' });
      return;
    }

    if (!telegram) {
      toast.error('Telegram support is currently unavailable.', { id: 'support' });
      return;
    }

    window.open(telegram, '_blank');
  }, [contactSupport, isAuthenticated]);

  return {
    whatsapp: contactSupport?.whatsapp ?? null,
    telegram: contactSupport?.telegram ?? null,
    handleWhatsAppSupportClick,
    handleTelegramSupportClick,
  };
};

export default useContactSupport;
